// frontend/src/utils/formatters.js

export const formatUnixDate = (unixVal, { hideSeconds = false, dateOnly = false, timeOnly = false } = {}) => {
  if (!unixVal || unixVal === 0) return "No programado";

  const dateMs = String(unixVal).length > 10 ? unixVal : unixVal * 1000;
  const d = new Date(dateMs);

  const pad = (n) => n.toString().padStart(2, '0');
  const datePart = `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())}`;
  const timePart = hideSeconds
    ? `${pad(d.getHours())}:${pad(d.getMinutes())}`
    : `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;

  if (dateOnly) return datePart;
  if (timeOnly) return timePart;
  return `${datePart} ${timePart}`;
};

export const formatCompact = (num) => {
  if (num == null) return "0";
  if (num <= 999) return num.toString();
  if (num < 1000000) return (num / 1000).toFixed(1) + 'k';
  return (num / 1000000).toFixed(2) + 'M';
};

// export const formatTime = (seconds) => {
//   if (seconds == null) return "0.0s";
//   if (seconds <= 999.99) return `${seconds.toFixed(1)}s`;
//   if (seconds < 3600) return `${(seconds / 60).toFixed(1)}m`;
//   return `${(seconds / 3600).toFixed(1)}h`;
// };

export const formatTime = (seconds, decimals = 1) => {
  // Si viene vacío o inválido, devuelve 0 con la cantidad de decimales pedida
  if (seconds === null || seconds === undefined || isNaN(seconds)) {
    return `${Number(0).toFixed(decimals)}s`;
  }

  const sec = Number(seconds);

  // Si es menor a un minuto, muestra solo los segundos
  if (sec < 60) {
    return `${sec.toFixed(decimals)}s`;
  }

  // Si es mayor a un minuto, lo divide en minutos y segundos
  const minutes = Math.floor(sec / 60);
  const remainingSeconds = (sec % 60).toFixed(decimals);

  return `${minutes}m ${remainingSeconds}s`;
};

// 🟢 TRADUCTOR DE CRON A TEXTO HUMANO
export const translateCron = (cron, frequency) => {
  if (frequency === 'once' || !cron) return 'Manual / 1 Vez';
  if (frequency === 'custom') return 'CRON Personalizado';

  const parts = cron.split(' ');
  if (parts.length !== 5) return 'Programado';

  const [min, hour, dom, mon, dow] = parts;
  const pad = (n) => n.toString().padStart(2, '0');

  if (min.includes('/')) return `Cada ${min.split('/')[1]} min`;
  if (hour.includes('/')) return `Cada ${hour.split('/')[1]} horas`;

  if (!hour.includes('*') && !hour.includes('-')) {
    let days = 'Diario';
    if (dow === '1,2,3,4,5') days = 'Lun-Vie';
    else if (dow !== '*') days = 'Días selectos';

    if (dom !== '*') {
      if (dom.includes(',')) return `Quincenal (${pad(hour)}:${pad(min)})`;
      return `Mensual, día ${dom} (${pad(hour)}:${pad(min)})`;
    }
    return `${days}, ${pad(hour)}:${pad(min)}`;
  }
  return 'Programado (Auto)';
};

/**
 * Traduce un errorMessage de log_migrate_result al idioma del visualizador.
 *
 * Soporta dos formatos:
 *   1. JSON estructurado: '{"code":"ERR_CAP_REACHED","params":{...}}'
 *      → busca t('errors.ERR_CAP_REACHED', params) y devuelve string traducido.
 *   2. String plano (legacy): "Failed 5 rows. Example: ..."
 *      → devuelve tal cual.
 *
 * Si el mensaje contiene un JSON estructurado seguido de "| <texto>" (caso
 * cap_hit + errores previos), traduce solo el JSON y concatena el resto.
 *
 * @param {string|null} errorMessage - El campo errorMessage de la BD.
 * @param {function} t - La función traductora del useLanguageStore.
 * @returns {string} Mensaje listo para mostrar al usuario.
 */
export const formatErrorMessage = (errorMessage, t) => {
  if (!errorMessage) return '';

  // Detectar si empieza con JSON estructurado
  const trimmed = errorMessage.trim();
  if (!trimmed.startsWith('{')) return errorMessage;  // Legacy plano

  try {
    // Separar el JSON del posible sufijo " | <texto>"
    // Buscamos el cierre correcto del primer objeto JSON.
    let depth = 0;
    let endIdx = -1;
    for (let i = 0; i < trimmed.length; i++) {
      if (trimmed[i] === '{') depth++;
      else if (trimmed[i] === '}') {
        depth--;
        if (depth === 0) { endIdx = i + 1; break; }
      }
    }
    if (endIdx === -1) return errorMessage;

    const jsonPart = trimmed.substring(0, endIdx);
    const suffixPart = trimmed.substring(endIdx).replace(/^\s*\|\s*/, '').trim();

    const parsed = JSON.parse(jsonPart);
    if (!parsed.code) return errorMessage;

    const translated = t(`errors.${parsed.code}`, parsed.params || {});
    return suffixPart ? `${translated} | ${suffixPart}` : translated;

  } catch (err) {
    // Si el parseo falla, devolver el original — fallback seguro.
    console.warn('formatErrorMessage: no se pudo parsear', err);
    return errorMessage;
  }
};
